import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { FlexColumn, FlexRow } from 'src/components/Atoms/FlexBox';
import Button from '@mui/material/Button';
interface PromoBannerProps {
  image?: React.ElementType | null;
  title: string;
  description: string;
  buttonText: string;
  buttonStartIcon?: React.ElementType | null;
  onButtonClick?: null | (() => void);
}
const BannerContainer = styled(FlexColumn)(({
  theme
}) => ({
  maxWidth: '100rem',
  marginTop: theme.sizes.spacing['10'],
  padding: `${theme.sizes.spacing['07']} ${theme.sizes.spacing['07']} ${theme.sizes.spacing['06']}`,
  alignItems: 'flex-start',
  gap: theme.sizes.spacing['08'],
  alignSelf: 'stretch',
  borderRadius: theme.sizes.radius.lg,
  background: `linear-gradient(
  -90deg,
  ${theme.colors.border.brand} -10%,
    ${theme.colors.surface.tertiary} 7%,
    ${theme.colors.border.brand} 40%,
    ${theme.colors.surface.brand} 80%
  )`,
  '& .MuiTypography-root': {
    color: theme.colors.text.inverted
  }
}));
const Content = styled(FlexRow)(({
  theme
}) => ({
  alignItems: 'center',
  gap: theme.sizes.spacing['09'],
  alignSelf: 'stretch'
}));
const ImageAndText = styled(FlexRow)(({
  theme
}) => ({
  alignItems: 'center',
  gap: theme.sizes.spacing['08'],
  flex: '1 0 0'
}));
const TextContainer = styled(FlexColumn)(() => ({
  width: '100%',
  justifyContent: 'center',
  alignItems: 'flex-start'
}));
const PromoBanner: React.FC<PromoBannerProps> = t0 => {
  const $ = _c(19);
  const {
    image: t1,
    title,
    description,
    buttonText,
    buttonStartIcon: t2,
    onButtonClick: t3
  } = t0;
  const Image = t1 === undefined ? null : t1;
  const StartIcon = t2 === undefined ? null : t2;
  const onButtonClick = t3 === undefined ? null : t3;
  let t4;
  if ($[0] !== Image) {
    t4 = Image && <Image />;
    $[0] = Image;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== title) {
    t5 = <Typography variant="h5">{title}</Typography>;
    $[2] = title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== description) {
    t6 = <Typography variant="body1">{description}</Typography>;
    $[4] = description;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <TextContainer>{t5}{t6}</TextContainer>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t7) {
    t8 = <ImageAndText>{t4}{t7}</ImageAndText>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== StartIcon || $[13] !== buttonText || $[14] !== onButtonClick) {
    t9 = onButtonClick && <Button variant="outlined" onClick={onButtonClick}>{StartIcon && <StartIcon />}{buttonText}</Button>;
    $[12] = StartIcon;
    $[13] = buttonText;
    $[14] = onButtonClick;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <BannerContainer><Content>{t8}{t9}</Content></BannerContainer>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default PromoBanner;
export type { PromoBannerProps };